import { FC } from 'react';

import { useStaffUsers } from 'src/hooks/subscription/useStaffUsers';

import StaffTable from './StaffTable/StaffTable';

/**
 * 직원(admin, manager) 목록을 표시하는 컴포넌트
 */
const StaffList: FC = () => {
  const { staffUsers } = useStaffUsers();

  return (
    <div className='height100 flexColumn'>
      <StaffTable rowData={staffUsers} />
    </div>
  );
};

export default StaffList;
